import { styled } from '@mui/material';

export const StyledOption = styled('li')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',

  // Styles of label in option
  '& > label': {
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
  },
});
